import React, { Component, useEffect, useState } from 'react'


import { loadLanguages, deleteLanguage } from '../utils/Network'
import { Link } from 'react-router-dom';
import LanguageContent from './LanguageContent';
export default function LanguagesContent({id}) {

    const [loading, setLoading] = useState(0);
    const [pageloading, setPageLoading] = useState(false);

    const [languages, setLanguages] = useState(null);

    

    useEffect(() => {
        setPageLoading(true)
        loadLanguages().then(languages => {
            setLanguages(languages);
            setPageLoading(false)
        });
    }, []);

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteLanguage(id).then(() => {
            loadLanguages().then(languages => {
                setLanguages(languages);

            });;
        })
    }

    return (
        <>
            <div className="content-wrapper">
                <section class="content-header hide-on-small">
                    <h1>
                        Languages
                            <small>({languages && languages.length}) items</small>
                    </h1>
                    <ol class="breadcrumb">
                        <li><a href="/cms"><i class="fa fa-dashboard"></i> Home</a></li>
                        <li class="active">Languages</li>
                    </ol>
                </section>

                <section className="content">

                    <div className="row">
                        <div className="col-md-6">

                            <div class="box box-primary">
                                <div class="box-header with-border">
                                    <h3 class="box-title">All Languages</h3>
                                    <a href="/cms/translate" title="Translation" className="btn btn-orange pull-right "><i className="fa fa-book"></i></a>
                                </div>
                                <div className="box-body no-padding">
                                    {pageloading && (<>
                                        <div class="overlay"><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
                                    </>)}
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Abbreviation</th>
                                                <th>Default</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {languages && languages.map((item) => (
                                                <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                                    <td>
                                                        <p>{item.name}</p>
                                                        <div className="btn-group">
                                                            <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                            <a href={`languages/${item.id}`} className="btn btn-default btn-sm">
                                                                <i className="fa fa-edit"></i>
                                                            </a>
                                                            

                                                        </div>
                                                    </td>
                                                    <td>{item.abbreviation}</td>


                                                    <td>{item.is_default ? (<i className="fa fa-check"></i>) : (<i className="fa fa-remove color-grey"></i>)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>Name</th>
                                                <th>Abbreviation</th>
                                                <th>Default</th>

                                            </tr>
                                        </tfoot>
                                    </table>

                                </div>


                            </div>


                        </div>
                   
                        <LanguageContent id={id} />
                    </div>

                </section>

            </div>
        </>



    )
}
